import { AccountTree } from '@mui/icons-material'

const crmIndex = {
  icon: AccountTree,
}

export default crmIndex
